/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicoststoptitle3Inputs */

const en_aicoststoptitle3 = /** @type {(inputs: Aicoststoptitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costliest businesses over the last 30 days`)
};

const de_aicoststoptitle3 = /** @type {(inputs: Aicoststoptitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teuerste Unternehmen der letzten 30 Tage`)
};

/**
* | output |
* | --- |
* | "Costliest businesses over the last 30 days" |
*
* @param {Aicoststoptitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicoststoptitle3 = /** @type {((inputs?: Aicoststoptitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicoststoptitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicoststoptitle3(inputs)
	return de_aicoststoptitle3(inputs)
});
export { aicoststoptitle3 as "aiCostsTopTitle" }